/**
 * enumants for PIP Thank You Component
 */

export enum DefaultNote {
  Note = `Your UM/UIM coverage selections are now complete and are documented on the PDF copies of the selection forms.  You may now close your browser to exit this process.`,
}

export enum DigitalContent {
  WithPip = `Thank you for completing the UM/UIM forms. Continue to your PIP coverage selections. Click below to download the signed forms. A copy will be sent to your email as well.`,
  WithoutPip = `Click below to download the signed forms. A copy will be sent to your email as well.`,
}

export enum NonDigitalContent {
  WithPip = `You have opted out of electronic coverage selection. Please download the coverage selection forms using the link below. These forms must be completed, signed and emailed to your underwriter with a copy sent to um-uim-pip@aig.com prior to the policy effective date.`,
  WithoutPip = `You have opted out of Electronic Election and Signature. A copy of the forms will be sent to the address you have provided. Please allow for 3-10 business days to receive these forms. Please note they need to be completed and returned to AIG prior to the effective date.`,
  rejectionOptMessage = `You have opted out of electronic coverage selection. The coverage selection forms will be mailed to the address you have provided. Please allow 3-10 business days for receipt. The selection forms must be completed, signed and received by your underwriter prior to the policy effective date.`,
}

// Error and console messages
export enum Messages {
  ErrorFetchingData = 'UIMUI Thank you page= Error fetching fresh request data.',
  DocumentsUnavailableError = "We're unable to process your download request at this time. You will receive an email containing your completed forms when this issue is resolved.",
  PdfGenerationError = 'Error generating PDF.',
}

// File names
export enum FileNames {
  PipDocuments = 'PIP Documents.pdf',
}
